import { Divider, Modal, ModalProps, Typography } from 'antd'
import Markdown from 'react-markdown'
import remarkGfm from 'remark-gfm'

interface InformationModal extends ModalProps {
  content: string
  title: string
  id: string
}

export function InformationModal({
  content,
  title,
  id,
  ...rest
}: InformationModal) {
  return (
    <Modal
      {...rest}
      centered
      footer={<></>}
      title={title ?? 'Изменения и улучшения'}
    >
      <Markdown
        components={{
          h1(props) {
            const { node, ...rest } = props

            return <Typography.Title level={1} {...rest} />
          },
          h2(props) {
            const { node, ...rest } = props

            return <Typography.Title level={2} {...rest} />
          },
          h3(props) {
            const { node, ...rest } = props

            return <Typography.Title level={3} {...rest} />
          },
          h4(props) {
            const { node, ...rest } = props

            return <Typography.Title level={4} {...rest} />
          },
          h5(props) {
            const { node, ...rest } = props

            return <Typography.Title level={5} {...rest} />
          },
          p(props) {
            const { node, ...rest } = props

            return <Typography.Paragraph {...rest} />
          },
          a(props) {
            const { node, ...rest } = props

            console.log('test')
            return (
              <Typography.Link
                rel="noopener noreferrer"
                target="_blank"
                {...rest}
              />
            )
          },
          ul(props) {
            console.log(props)
            const { node, ...rest } = props

            return (
              <Typography.Paragraph>
                <ul {...rest}></ul>
              </Typography.Paragraph>
            )
          },
          hr(props) {
            const { node, ...rest } = props

            return <Divider {...rest} />
          },
          blockquote(props) {
            const { node, ...rest } = props

            return (
              <Typography.Paragraph>
                <blockquote {...rest} />
              </Typography.Paragraph>
            )
          },
          img(props) {
            return (
              <img
                alt={props.alt}
                src={props.src}
                style={{
                  width: '100%',
                }}
              ></img>
            )
          },
        }}
        remarkPlugins={[remarkGfm]}
      >
        {content}
      </Markdown>
    </Modal>
  )
}
